import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';

const EthnicityFilterIcon = (props: any) => {
  const theme = useContext(ThemeContext);
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M10 12C11.1046 12 12 11.1046 12 10C12 8.89543 11.1046 8 10 8C8.89543 8 8 8.89543 8 10C8 11.1046 8.89543 12 10 12Z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 12C17.1046 12 18 11.1046 18 10C18 8.89543 17.1046 8 16 8C14.8954 8 14 8.89543 14 10C14 11.1046 14.8954 12 16 12Z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 6C11.1046 6 12 5.10457 12 4C12 2.89543 11.1046 2 10 2C8.89543 2 8 2.89543 8 4C8 5.10457 8.89543 6 10 6Z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 18C11.1046 18 12 17.1046 12 16C12 14.8954 11.1046 14 10 14C8.89543 14 8 14.8954 8 16C8 17.1046 8.89543 18 10 18Z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4 12C5.10457 12 6 11.1046 6 10C6 8.89543 5.10457 8 4 8C2.89543 8 2 8.89543 2 10C2 11.1046 2.89543 12 4 12Z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.53033 4.46967C5.23744 4.17678 4.76256 4.17678 4.46967 4.46967C4.17678 4.76256 4.17678 5.23744 4.46967 5.53033L5.53033 4.46967ZM7.46967 8.53033L8 9.06066L9.06066 8L8.53033 7.46967L7.46967 8.53033ZM4.46967 5.53033L7.46967 8.53033L8.53033 7.46967L5.53033 4.46967L4.46967 5.53033Z"
        fill={theme.colors.neutrals.c400}
        stroke="transparent"
      />
      <path
        d="M12.5303 11.4697L12 10.9393L10.9393 12L11.4697 12.5303L12.5303 11.4697ZM14.4697 15.5303C14.7626 15.8232 15.2374 15.8232 15.5303 15.5303C15.8232 15.2374 15.8232 14.7626 15.5303 14.4697L14.4697 15.5303ZM11.4697 12.5303L14.4697 15.5303L15.5303 14.4697L12.5303 11.4697L11.4697 12.5303Z"
        fill={theme.colors.neutrals.c400}
        stroke="transparent"
      />
      <path
        d="M8.53033 12.5303L9.06066 12L8 10.9393L7.46967 11.4697L8.53033 12.5303ZM4.46967 14.4697C4.17678 14.7626 4.17678 15.2374 4.46967 15.5303C4.76256 15.8232 5.23744 15.8232 5.53033 15.5303L4.46967 14.4697ZM7.46967 11.4697L4.46967 14.4697L5.53033 15.5303L8.53033 12.5303L7.46967 11.4697Z"
        fill={theme.colors.neutrals.c400}
        stroke="transparent"
      />
      <path
        d="M15.5303 5.53033C15.8232 5.23744 15.8232 4.76256 15.5303 4.46967C15.2374 4.17678 14.7626 4.17678 14.4697 4.46967L15.5303 5.53033ZM11.4697 7.46967L10.9393 8L12 9.06066L12.5303 8.53033L11.4697 7.46967ZM14.4697 4.46967L11.4697 7.46967L12.5303 8.53033L15.5303 5.53033L14.4697 4.46967Z"
        fill={theme.colors.neutrals.c400}
        stroke="transparent"
      />
      <path d="M6 10H8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M12 10H14" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M10 8V6" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M10 12V14" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export default EthnicityFilterIcon;
